// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"eba3255f","585":"f0575d32"}[chunkId] + ".chunk.js";
};